export const colors = {
  methods: {
    getColorRemains (value) {
      if (value === 0) {
        return 'grey clock'
      }

      if (value > 0 && value < 10) {
        return 'red'
      }

      if (value >= 10 && value < 50) {
        return 'blue'
      }

      if (value >= 50) {
        return 'green'
      }
      // infinity
    },
    getColorRemainsForCard (value) {
      if (value === 0) {
        return 'grey'
      }

      if (value > 0 && value < 10) {
        return 'red'
      }

      if (value >= 10 && value < 50) {
        return 'blue'
      }

      if (value >= 50) {
        return 'green'
      }
      // infinity
    },
    getOrderClassByStatus (value) {
      let orderClass = ''
      switch (value) {
        case 1: {
          break
        }
        case 2:
        case 4: {
          orderClass = 'attention'
          break
        }
        case 3: {
          orderClass = 'success'
          break
        }
      }
      return orderClass
    },
    getOrderStatusColor (value) {
      let orderClass = ''
      switch (value) {
        case 1: {
          orderClass = 'yellow'
          break
        }
        case 2: {
          orderClass = 'blue'
          break
        }
        case 3: {
          orderClass = 'green'
          break
        }
        case 4: {
          orderClass = 'red'
          break
        }
      }
      return orderClass
    },
    getOrderDeliveryColor (value) {
      let orderClass = ''
      switch (value) {
        case 1: {
          orderClass = 'grey'
          break
        }
        case 2: {
          orderClass = 'blue'
          break
        }
        case 3: {
          orderClass = 'orange'
          break
        }
        case 4: {
          orderClass = 'red'
          break
        }
        case 5: {
          orderClass = 'orange'
          break
        }
        case 6: {
          orderClass = 'green'
          break
        }
      }
      return orderClass
    }
  }
}
